import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const UsersFilter = ({ defaultUser, entityType = '', setUserCallback = () => { } }) => {
    const allUsersMenuItem = {
        id: undefined,
        name: 'All Users',
    };

    const [showDropdown, setShowDropdown] = useState(false);
    const [userFilterOptions] = useState([allUsersMenuItem]);
    const [selectedUser, setSelectedUser] = useState(defaultUser ?? allUsersMenuItem);

    useEffect(() => {
        try {
            const entityQueryString = entityType ? `entity=${entityType}` : '';
            fetch(`/api/users?${entityQueryString}`)
                .then((resp) => resp.json())
                .then((resp) => {
                    resp.data.users.forEach((user) => {
                        // display current user at top of list
                        if (config.user.id === user.id) {
                            userFilterOptions.unshift({
                                id: user.id,
                                name: user.name,
                            });
                        } else {
                            userFilterOptions.push({
                                id: user.id,
                                name: user.name,
                            });
                        }
                    });
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    const onDropdownClick = () => setShowDropdown(!showDropdown);
    const onSelectionChanged = (user) => {
        setSelectedUser(user);
        setUserCallback(user);
        setShowDropdown(false);
    };

    return (
        <div className='dropdown'>
            <button
                className='input-dropdown-toggle dropdown__toggle dropdown-toggle'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
                type='button'
                onClick={onDropdownClick}
                value={selectedUser}
            >
                <span>
                    {selectedUser.name}
                </span>
                <i className={`dropdown__toggle-indicator fa ${showDropdown ? 'fa-angle-up' : 'fa-angle-down'}`}/>
            </button>
            {userFilterOptions
                && <ul className='dropdown__menu' style={{ display: showDropdown ? 'block' : 'none' }}>
                    {userFilterOptions.map((user, index) => (
                        <li
                            key={index}
                            className={`dropdown__menu-item ${user.name === selectedUser.name ? 'selected' : ''}`}
                            onClick={() => onSelectionChanged(user)}
                            value={user}
                        >
                            { user.name }
                        </li>
                    ))}
                </ul>
            }
        </div>
    );
};

UsersFilter.propTypes = {
    defaultUser: PropTypes.object,
    entityType: PropTypes.string,
    setUserCallback: PropTypes.func,
};

export default UsersFilter;
